<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">แก้ไขชาวบ้าน</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- Loading State -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-indigo-600 mx-auto"></div>
              <p class="mt-2 text-indigo-200">กำลังโหลดข้อมูล...</p>
            </div>

            <!-- Tab Navigation -->
            <div v-else class="flex border-b border-gray-700 mb-6">
              <button
                v-for="tab in tabs"
                :key="tab.id"
                @click="activeTab = tab.id"
                class="px-4 py-2 text-sm font-medium transition-colors duration-200"
                :class="activeTab === tab.id ? 'text-indigo-200 border-b-2 border-indigo-700' : 'text-gray-400 hover:text-indigo-300'"
              >
                {{ tab.name }}
              </button>
            </div>

            <!-- ฟอร์ม -->
            <form  @submit.prevent="handleUpdateVillager">
              <div class="space-y-4 h-96 overflow-auto mb-6">
                <!-- General Tab -->
                <div v-if="activeTab === 'general'" class="space-y-4">
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อชาวบ้าน</label>
                      <input 
                        v-model="villagerData.name" 
                        type="text" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">เลเวล</label>
                      <select 
                        v-model.number="villagerData.level" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทชาวบ้าน</label>
                      <select 
                        v-model="villagerData.type" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="นักรบรับจ้าง">นักรบรับจ้าง</option>
                        <option value="อันธพาล">อันธพาล</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพชาวบ้าน</label>
                      <input 
                        v-model="villagerData.img" 
                        type="url" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="https://example.com/image.jpg"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปหน้าปกติ</label>
                      <input 
                        v-model="villagerData.normalFace" 
                        type="url" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="https://example.com/normal-face.jpg"
                      >
                    </div>
                  </div>
                </div>

                <!-- Phrases & Locations Tab -->
                <div v-if="activeTab === 'phrases'" class="space-y-4">
                  <!-- คำพูดที่ชอบพูด -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">คำพูดที่ชอบพูด</h4>
                    <div v-for="(phrase, index) in villagerData.phrases" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-10">
                        <input 
                          v-model="villagerData.phrases[index]" 
                          type="text" 
                          placeholder="คำพูด"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button 
                          v-if="index > 0"
                          @click="removePhrase(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบคำพูด"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button 
                        @click="addPhrase"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มคำพูด
                      </button>
                    </div>
                  </div>

                  <!-- สถานที่ตั้งที่สามารถไปได้ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">สถานที่ตั้งที่สามารถไปได้</h4>
                    <div v-for="(location, index) in villagerData.locations" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-10">
                        <input 
                          v-model="villagerData.locations[index]" 
                          type="text" 
                          placeholder="สถานที่ เช่น Forest"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button 
                          v-if="index > 0"
                          @click="removeLocation(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบสถานที่"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button 
                        @click="addLocation"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มสถานที่
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Stats & Dice Tab -->
                <div v-if="activeTab === 'stats'" class="space-y-4">
                  <!-- ค่าใช้จ่ายในการจ้าง -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ค่าใช้จ่ายในการจ้าง</h4>
                    <div class="grid grid-cols-3 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Silver</label>
                        <input 
                          v-model.number="villagerData.hireCosts.silver" 
                          type="number" 
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Gold</label>
                        <input 
                          v-model.number="villagerData.hireCosts.gold" 
                          type="number" 
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Diamond</label>
                        <input 
                          v-model.number="villagerData.hireCosts.diamond" 
                          type="number" 
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                    </div>
                  </div>

                  <!-- ค่าสถานะ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ ({{ villagerData.stats.stamina + villagerData.stats.str + villagerData.stats.int + villagerData.stats.agi + villagerData.stats.defense + villagerData.stats.luck }})</h4>
                    <div class="grid grid-cols-2 sm:grid-cols-6 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                        <input
                          v-model.number="villagerData.stats.stamina"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                        <input
                          v-model.number="villagerData.stats.str"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                        <input
                          v-model.number="villagerData.stats.agi"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                        <input
                          v-model.number="villagerData.stats.int"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                        <input
                          v-model.number="villagerData.stats.luck"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                        <input
                          v-model.number="villagerData.stats.defense"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- จำนวนลูกเต๋า -->
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนลูกเต๋าฝ่ายบุก</label>
                      <input 
                        v-model.number="villagerData.attackDice" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนลูกเต๋าฝ่ายตั้งรับ</label>
                      <input 
                        v-model.number="villagerData.defenseDice" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                </div>

                <!-- Weapons & Perks Tab -->
                <div v-if="activeTab === 'weapons'" class="space-y-4">
                  <!-- อาวุธ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">อาวุธ</h4>
                    <select 
                      v-model="villagerData.weapon" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                      <option value="">เลือกอาวุธ</option>
                      <option v-for="weapon in weapons" :key="weapon.value" :value="weapon.value">
                        {{ weapon.label }}
                      </option>
                    </select>
                  </div>

                  <!-- อาวุธที่ชนะทาง -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">อาวุธที่ชนะทาง (เลือกหลาย)</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <label v-for="weapon in weapons" :key="weapon.value" class="flex items-center text-gray-300">
                        <input type="checkbox" v-model="villagerData.strongAgainst" :value="weapon.value" class="mr-2 form-checkbox h-5 w-5 text-indigo-600 bg-gray-700 border-gray-600 rounded focus:ring-indigo-500">
                        {{ weapon.label }}
                      </label>
                    </div>
                  </div>

                  <!-- อาวุธที่แพ้ทาง -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">อาวุธที่แพ้ทาง (เลือกหลาย)</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <label v-for="weapon in weapons" :key="weapon.value" class="flex items-center text-gray-300">
                        <input type="checkbox" v-model="villagerData.weakAgainst" :value="weapon.value" class="mr-2 form-checkbox h-5 w-5 text-indigo-600 bg-gray-700 border-gray-600 rounded focus:ring-indigo-500">
                        {{ weapon.label }}
                      </label>
                    </div>
                  </div>

                  <!-- Perks -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">Perks (เลือกได้หลายตัว)</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <label v-for="(perk, index) in availablePerks" :key="index" class="flex items-center text-gray-300">
                        <input type="checkbox" v-model="villagerData.perks" :value="perk.name" class="mr-2 form-checkbox h-5 w-5 text-indigo-600 bg-gray-700 border-gray-600 rounded focus:ring-indigo-500">
                        {{ perk.name }} - {{ perk.description }}
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Upgrade Items Tab -->
                <div v-if="activeTab === 'upgrade'" class="space-y-4">
                  <h4 class="text-lg font-medium text-gray-300">ไอเท็มสำหรับอัปเกรดระดับ (เหมือนกันทุกเลเวล)</h4>
                  <!-- List of item names -->
                  <div class="space-y-4 mb-6">
                    <div v-for="(itemName, index) in villagerData.upgradeItemNames" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-10">
                        <input 
                          v-model="villagerData.upgradeItemNames[index]" 
                          type="text" 
                          placeholder="ชื่อไอเท็ม เช่น เสื้อคลุมทหาร"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button 
                          v-if="villagerData.upgradeItemNames.length > 1"
                          @click="removeUpgradeItem(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบไอเท็ม"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button 
                        @click="addUpgradeItem"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มชื่อไอเท็ม
                      </button>
                    </div>
                  </div>
                  <!-- Quantity -->
                  <div class="space-y-4 mb-6">
                    <label class="block text-sm font-medium text-gray-300">จำนวนไอเท็มที่ต้องใช้ (จากชื่อใดชื่อหนึ่ง)</label>
                    <input 
                      v-model.number="villagerData.upgradeQuantity" 
                      type="number" 
                      min="1"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                  </div>
                  <!-- Level Upgrade Costs (Diamond & Gold) -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ค่าอัปเกรดเลเวล (diamond และ gold สำหรับเลเวล 1-10)</h4>
                    <div class="grid grid-cols-3 gap-4 font-medium text-gray-300 text-sm">
                      <div>เลเวล (อัปไปถัดไป)</div>
                      <div>Diamond</div>
                      <div>Gold</div>
                    </div>
                    <div v-for="lv in 9" :key="lv" class="grid grid-cols-3 gap-4 items-center">
                      <div class="text-gray-300">{{ lv }} → {{ lv + 1 }}</div>
                      <input 
                        v-model.number="villagerData.diamondCosts[lv-1]" 
                        type="number" 
                        min="0"
                        class="px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                      <input 
                        v-model.number="villagerData.goldCosts[lv-1]" 
                        type="number" 
                        min="0"
                        class="px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button 
                  type="button"
                  @click="handleDeleteVillager"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                  ลบชาวบ้าน
                </button>
                <button 
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  อัปเดตชาวบ้าน
                </button>
                <button 
                  @click="$emit('cancelModal')" 
                  type="button" 
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  props: ['villagerId'],
  emits: ['cancelModal', 'villagerUpdated', 'villagerDeleted'],
  setup(props, { emit }) {
    const villagerData = ref({
      name: '',
      img: '',
      normalFace: '',
      phrases: [''],
      locations: [''],
      hireCosts: { silver: 0, gold: 0, diamond: 0 },
      stats: {
        stamina: 0,
        str: 0,
        int: 0,
        agi: 0,
        defense: 0,
        luck: 0,
      },
      level: 1,
      type: 'นักรบรับจ้าง',
      attackDice: 0,
      defenseDice: 0,
      weapon: '',
      strongAgainst: [],
      weakAgainst: [],
      perks: [],
      upgradeItemNames: [''], // Changed: array of string names
      upgradeQuantity: 1, // Changed: single number for quantity
      diamondCosts: Array(9).fill(0), // Costs for lv1->2 to lv9->10
      goldCosts: Array(9).fill(0) // Costs for lv1->2 to lv9->10
    });
    const isLoading = ref(true);
    const activeTab = ref('general');
    const tabs = ref([
      { id: 'general', name: 'ข้อมูลทั่วไป' },
      { id: 'phrases', name: 'คำพูด & สถานที่' },
      { id: 'stats', name: 'สถานะ & ลูกเต๋า' },
      { id: 'weapons', name: 'อาวุธ & Perks' },
      { id: 'upgrade', name: 'ไอเท็มอัปเกรด' },
    ]);

    // Available perks list
    const availablePerks = ref([
      { name: 'ผู้รอดชีวิต', description: 'ถ้าถูกฆ่าตายมีโอกาสกลับไปที่แคมป์ (โอกาส 50%)' },
      { name: 'บ้าคลั่ง', description: 'เมื่อมีเลือดต่ำกว่า 50 % มีโอกาเพิ่มลูกเต๋า 1 ลูก (โอกา 20%)' },
      { name: 'นักวางกับดัก', description: 'เมื่ออยู่ฝ่ายป้องกันมีโอกาสเพิ่มลูกเต๋า 1 ลูก (โอกาส 20%)' },
      { name: 'นักบุกโจมตี', description: 'เมื่ออยู่ฝ่ายโจมตีมีโอกาสเพิ่มลูกเต๋า 1 โอกาส (โอกาส 20%)' },
      { name: 'อึดถึกทน', description: 'ลดดาเมจที่ได้รับ 20% (โอกาส 30%)' },
      { name: 'ฟื้นตัวไว', description: 'รักษาเลือด 10% max HP หลังรอบ (โอกาส 10%)' },
      { name: 'หลอกล่อ', description: 'มีโอกาสทำให้อีกฝ่ายลดลูกเต๋า 1 ลูก (โอกาส 20%)' },
      { name: 'ผู้มีบุญ', description: 'เมื่อ hp เหลือ 0 มีโอกาสที่จะไม่ตายและกลับมามีเลือด 20% (โอกาส 10%)' },
      { name: 'หัวหน้าทีม', description: 'Heal ทีม 10 % max HP หลังรอบ (โอกาส 10%)' },
      { name: 'ฆาตกรโรคจิต', description: 'มีโอกาส +2 dice ถ้าทีมเหลือ 2 คน (โอกาส 20%)' },
      { name: 'นักเจรจา', description: 'เมื่อทอยลูกเต๋าแพ้มีโอกาสที่จะไม่โดนโจมตีเลย (โอกาส 10%)' },
      { name: 'ผู้ใช้อาวุธระยะไกล', description: '+10% crit ถ้าแต้มลูกเต๋านำมากกว่า 3 แต้ม (โอกาส 100%)' }
    ]);

    const weapons = ref([
      { value: 'ดาบใหญ่', label: 'ดาบใหญ่' },
      { value: 'ดาบคู่', label: 'ดาบคู่' },
      { value: 'มีดสั้น', label: 'มีดสั้น' },
      { value: 'ธนู', label: 'ธนู' },
      { value: 'เลื่อยไฟฟ้า', label: 'เลื่อยไฟฟ้า' },
      { value: 'หอก', label: 'หอก' },
      { value: 'ถุงมือ', label: 'ถุงมือ' },
      { value: 'ค้อน', label: 'ค้อน' },
      { value: 'ขวาน', label: 'ขวาน' },
      { value: 'กระบอง', label: 'กระบอง' }
    ]);

    // Phrases
    const addPhrase = () => {
      villagerData.value.phrases.push('');
    };

    const removePhrase = (index) => {
      if (villagerData.value.phrases.length > 1) {
        villagerData.value.phrases.splice(index, 1);
      }
    };

    // Locations
    const addLocation = () => {
      villagerData.value.locations.push('');
    };

    const removeLocation = (index) => {
      if (villagerData.value.locations.length > 1) {
        villagerData.value.locations.splice(index, 1);
      }
    };

    // Upgrade Items
    const addUpgradeItem = () => {
      villagerData.value.upgradeItemNames.push('');
    };

    const removeUpgradeItem = (index) => {
      if (villagerData.value.upgradeItemNames.length > 1) {
        villagerData.value.upgradeItemNames.splice(index, 1);
      }
    };

    const namePresets = {
      // === กลุ่ม 1-10: 9 Perks (1 ผู้รอดชีวิต + 8 สุ่ม), ชนะทาง 6 อาวุธ, แพ้ทาง 0 อาวุธ ===
      // 1. สินธูชล (อาวุธ: หอก)
      'สินธูชล': {
        weapon: 'หอก',
        strongAgainst: ['ดาบคู่', 'ค้อน', 'ขวาน', 'กระบอง', 'มีดสั้น', 'เลื่อยไฟฟ้า'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 198,
          str: 171,
          int: 43,
          agi: 31,
          luck: 20,
          defense: 29,
        },
      },
      // 2. วายุเพลิง (อาวุธ: เลื่อยไฟฟ้า)
      'วายุเพลิง': {
        weapon: 'เลื่อยไฟฟ้า',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'หอก', 'ถุงมือ', 'ค้อน', 'ขวาน'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 200,
          str: 169,
          int: 40,
          agi: 26,
          luck: 23,
          defense: 29,
        },
      },
      // 3. เมขลาพายุ (อาวุธ: กระบอง)
      'เมขลาพายุ': {
        weapon: 'กระบอง',
        strongAgainst: ['ดาบคู่', 'มีดสั้น', 'ธนู', 'เลื่อยไฟฟ้า', 'หอก', 'ถุงมือ'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 200,
          str: 166,
          int: 39,
          agi: 29,
          luck: 22,
          defense: 28,
        },
      },
      // 4. ปรัชญาเทพ (อาวุธ: ดาบคู่)
      'ปรัชญาเทพ': {
        weapon: 'ดาบคู่',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'ธนู', 'เลื่อยไฟฟ้า', 'ค้อน', 'ขวาน'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 194,
          str: 167,
          int: 40,
          agi: 28,
          luck: 22,
          defense: 28,
        },
      },
      // 5. ศิลาเกรียงไกร (อาวุธ: ขวาน)
      'ศิลาเกรียงไกร': {
        weapon: 'ขวาน',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'มีดสั้น', 'เลื่อยไฟฟ้า', 'หอก', 'ถุงมือ'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 191,
          str: 162,
          int: 39,
          agi: 26,
          luck: 20,
          defense: 31,
        },
      },
      // 6. เกริกวายุ (อาวุธ: ค้อน)
      'เกริกวายุ': {
        weapon: 'ค้อน',
        strongAgainst: ['ดาบคู่', 'มีดสั้น', 'ธนู', 'หอก', 'ถุงมือ', 'กระบอง'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 200,
          str: 164,
          int: 40,
          agi: 31,
          luck: 23,
          defense: 31,
        },
      },
      // 7. เทพยงค์ (อาวุธ: ธนู) - **มี Perk ผู้ใช้อาวุธระยะไกล (รวม 9 Perks)**
      'เทพยงค์': {
        weapon: 'ธนู',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'มีดสั้น', 'เลื่อยไฟฟ้า', 'ถุงมือ', 'ค้อน'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'ผู้ใช้อาวุธระยะไกล', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 193,
          str: 161,
          int: 40,
          agi: 31,
          luck: 23,
          defense: 27,
        },
      },
      // 8. เดชนารายณ์ (อาวุธ: ถุงมือ)
      'เดชนารายณ์': {
        weapon: 'ถุงมือ',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'มีดสั้น', 'ธนู', 'เลื่อยไฟฟ้า', 'ค้อน'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 192,
          str: 164,
          int: 37,
          agi: 28,
          luck: 24,
          defense: 30,
        },
      },
      // 9. ดำรงศึก (อาวุธ: ดาบใหญ่)
      'ดำรงศึก': {
        weapon: 'ดาบใหญ่',
        strongAgainst: ['ดาบคู่', 'มีดสั้น', 'ธนู', 'หอก', 'ถุงมือ', 'ค้อน'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 192,
          str: 171,
          int: 38,
          agi: 28,
          luck: 24,
          defense: 30,
        },
      },
      // 10. คัมภีร์อสูร (อาวุธ: มีดสั้น)
      'คัมภีร์อสูร': {
        weapon: 'มีดสั้น',
        strongAgainst: ['ดาบใหญ่', 'ธนู', 'เลื่อยไฟฟ้า', 'หอก', 'ถุงมือ', 'กระบอง'],
        weakAgainst: [],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 193,
          str: 167,
          int: 40,
          agi: 27,
          luck: 23,
          defense: 29,
        },
      },
      // === กลุ่ม 11-20: 8 Perks (1 ผู้รอดชีวิต + 7 สุ่ม), ชนะทาง 5 อาวุธ, แพ้ทาง 1 อาวุธ ===
      // 11. มิรุง (อาวุธ: ดาบคู่)
      'มิรุง': {
        weapon: 'ดาบคู่',
        strongAgainst: ['มีดสั้น', 'ธนู', 'เลื่อยไฟฟ้า', 'หอก', 'ถุงมือ'],
        weakAgainst: ['กระบอง'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 218,
          str: 143,
          int: 38,
          agi: 32,
          luck: 23,
          defense: 39,
        },
      },
      // 12. เกริกไกร (อาวุธ: ค้อน)
      'เกริกไกร': {
        weapon: 'ค้อน',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'เลื่อยไฟฟ้า', 'ขวาน', 'กระบอง'],
        weakAgainst: ['หอก'],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'ผู้มีบุญ', 'หัวหน้าทีม'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 214,
          str: 143,
          int: 37,
          agi: 33,
          luck: 26,
          defense: 40,
        },
      },
      // 13. มาริส (อาวุธ: มีดสั้น)
      'มาริส': {
        weapon: 'มีดสั้น',
        strongAgainst: ['ดาบใหญ่', 'เลื่อยไฟฟ้า', 'หอก', 'ถุงมือ', 'ค้อน'],
        weakAgainst: ['ธนู'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'ฟื้นตัวไว', 'ผู้มีบุญ', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 206,
          str: 141,
          int: 43,
          agi: 35,
          luck: 25,
          defense: 38,
        },
      },
      // 14. ยศวุธ (อาวุธ: ขวาน)
      'ยศวุธ': {
        weapon: 'ขวาน',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'ธนู', 'เลื่อยไฟฟ้า', 'ค้อน'],
        weakAgainst: ['ถุงมือ'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'อึดถึกทน', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 209,
          str: 139,
          int: 43,
          agi: 34,
          luck: 22,
          defense: 43,
        },
      },
      // 15. กวินทร์ (อาวุธ: เลื่อยไฟฟ้า)
      'กวินทร์': {
        weapon: 'เลื่อยไฟฟ้า',
        strongAgainst: ['มีดสั้น', 'หอก', 'ถุงมือ', 'ขวาน', 'กระบอง'],
        weakAgainst: ['ดาบใหญ่'],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'ผู้มีบุญ', 'หัวหน้าทีม', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 210,
          str: 138,
          int: 42,
          agi: 32,
          luck: 22,
          defense: 37,
        },
      },
      // 16. สุรคม (อาวุธ: กระบอง)
      'สุรคม': {
        weapon: 'กระบอง',
        strongAgainst: ['ดาบคู่', 'มีดสั้น', 'หอก', 'ถุงมือ', 'ค้อน'],
        weakAgainst: ['เลื่อยไฟฟ้า'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 209,
          str: 137,
          int: 40,
          agi: 34,
          luck: 26,
          defense: 38,
        },
      },
      // 17. เวหะ (อาวุธ: ถุงมือ)
      'เวหะ': {
        weapon: 'ถุงมือ',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'ธนู', 'ค้อน', 'กระบอง'],
        weakAgainst: ['ขวาน'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'อึดถึกทน', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 210,
          str: 141,
          int: 43,
          agi: 34,
          luck: 23,
          defense: 40,
        },
      },
      // 18. พรตพิฆาต (อาวุธ: หอก)
      'พรตพิฆาต': {
        weapon: 'หอก',
        strongAgainst: ['ดาบใหญ่', 'เลื่อยไฟฟ้า', 'ถุงมือ', 'ขวาน', 'กระบอง'],
        weakAgainst: ['ดาบคู่'],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 206,
          str: 141,
          int: 42,
          agi: 31,
          luck: 26,
          defense: 42,
        },
      },
      // 19. พงศธร (อาวุธ: ดาบใหญ่)
      'พงศธร': {
        weapon: 'ดาบใหญ่',
        strongAgainst: ['มีดสั้น', 'ธนู', 'หอก', 'ถุงมือ', 'ค้อน'],
        weakAgainst: ['เลื่อยไฟฟ้า'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'หัวหน้าทีม'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 215,
          str: 141,
          int: 38,
          agi: 35,
          luck: 26,
          defense: 42,
        },
      },
      // 20. ฐาปกรณ์ (อาวุธ: ธนู) - **มี Perk ผู้ใช้อาวุธระยะไกล (รวม 8 Perks)**
      'ฐาปกรณ์': {
        weapon: 'ธนู',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'เลื่อยไฟฟ้า', 'หอก', 'กระบอง'],
        weakAgainst: ['มีดสั้น'],
        perks: ['ผู้รอดชีวิต', 'ผู้ใช้อาวุธระยะไกล', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 212,
          str: 138,
          int: 38,
          agi: 32,
          luck: 21,
          defense: 34,
        },
      },
      // === กลุ่ม 21-30: 7 Perks (1 ผู้รอดชีวิต + 6 สุ่ม), ชนะทาง 4 อาวุธ, แพ้ทาง 2 อาวุธ ===
      // 21. คีรินทร์ (อาวุธ: กระบอง)
      'คีรินทร์': {
        weapon: 'กระบอง',
        strongAgainst: ['มีดสั้น', 'ธนู', 'เลื่อยไฟฟ้า', 'ถุงมือ'],
        weakAgainst: ['ดาบใหญ่', 'ขวาน'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 200,
          str: 153,
          int: 38,
          agi: 50,
          luck: 25,
          defense: 24,
        },
      },
      // 22. ธันวา (อาวุธ: ค้อน)
      'ธันวา': {
        weapon: 'ค้อน',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'ถุงมือ', 'กระบอง'],
        weakAgainst: ['เลื่อยไฟฟ้า', 'หอก'],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'ผู้มีบุญ', 'หัวหน้าทีม'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 191,
          str: 150,
          int: 39,
          agi: 47,
          luck: 22,
          defense: 22,
        },
      },
      // 23. มุกริน (อาวุธ: ดาบคู่)
      'มุกริน': {
        weapon: 'ดาบคู่',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'ค้อน', 'ขวาน'],
        weakAgainst: ['ธนู', 'กระบอง'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักบุกโจมตี', 'หลอกล่อ', 'ผู้มีบุญ', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 192,
          str: 146,
          int: 43,
          agi: 55,
          luck: 21,
          defense: 26,
        },
      },
      // 24. อชิร (อาวุธ: ดาบใหญ่)
      'อชิร': {
        weapon: 'ดาบใหญ่',
        strongAgainst: ['ดาบคู่', 'เลื่อยไฟฟ้า', 'หอก', 'กระบอง'],
        weakAgainst: ['ถุงมือ', 'มีดสั้น'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'หัวหน้าทีม'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 190,
          str: 152,
          int: 38,
          agi: 50,
          luck: 23,
          defense: 20,
        },
      },
      // 25. พิรุณ (อาวุธ: หอก)
      'พิรุณ': {
        weapon: 'หอก',
        strongAgainst: ['มีดสั้น', 'ธนู', 'ถุงมือ', 'ค้อน'],
        weakAgainst: ['ดาบใหญ่', 'เลื่อยไฟฟ้า'],
        perks: ['ผู้รอดชีวิต', 'นักวางกับดัก', 'นักบุกโจมตี', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 190,
          str: 151,
          int: 43,
          agi: 52,
          luck: 23,
          defense: 27,
        },
      },
      // 26. ชยุต (อาวุธ: ธนู) - **มี Perk ผู้ใช้อาวุธระยะไกล (รวม 7 Perks)**
      'ชยุต': {
        weapon: 'ธนู',
        strongAgainst: ['ดาบคู่', 'มีดสั้น', 'เลื่อยไฟฟ้า', 'หอก'],
        weakAgainst: ['ค้อน', 'ขวาน'],
        perks: ['ผู้รอดชีวิต', 'ผู้ใช้อาวุธระยะไกล', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 191,
          str: 150,
          int: 37,
          agi: 51,
          luck: 26,
          defense: 26,
        },
      },
      // 27. วิศรุต (อาวุธ: มีดสั้น)
      'วิศรุต': {
        weapon: 'มีดสั้น',
        strongAgainst: ['ดาบคู่', 'หอก', 'ค้อน', 'ขวาน'],
        weakAgainst: ['ธนู', 'กระบอง'],
        perks: ['ผู้รอดชีวิต', 'อึดถึกทน', 'ฟื้นตัวไว', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 191,
          str: 148,
          int: 37,
          agi: 51,
          luck: 25,
          defense: 24,
        },
      },
      // 28. ภาคภูมิ (อาวุธ: ถุงมือ)
      'ภาคภูมิ': {
        weapon: 'ถุงมือ',
        strongAgainst: ['ดาบใหญ่', 'ดาบคู่', 'เลื่อยไฟฟ้า', 'ขวาน'],
        weakAgainst: ['หอก', 'ค้อน'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'ฟื้นตัวไว', 'หลอกล่อ', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 192,
          str: 150,
          int: 43,
          agi: 50,
          luck: 22,
          defense: 24,
        },
      },
      // 29. ภูริเดช (อาวุธ: ขวาน)
      'ภูริเดช': {
        weapon: 'ขวาน',
        strongAgainst: ['ดาบคู่', 'ธนู', 'ถุงมือ', 'ค้อน'],
        weakAgainst: ['มีดสั้น', 'เลื่อยไฟฟ้า'],
        perks: ['ผู้รอดชีวิต', 'อึดถึกทน', 'หลอกล่อ', 'ผู้มีบุญ', 'หัวหน้าทีม', 'ฆาตกรโรคจิต', 'นักเจรจา'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 195,
          str: 151,
          int: 37,
          agi: 54,
          luck: 21,
          defense: 26,
        },
      },
      // 30. ไผท (อาวุธ: เลื่อยไฟฟ้า)
      'ไผท': {
        weapon: 'เลื่อยไฟฟ้า',
        strongAgainst: ['ดาบใหญ่', 'มีดสั้น', 'หอก', 'กระบอง'],
        weakAgainst: ['ดาบคู่', 'ถุงมือ'],
        perks: ['ผู้รอดชีวิต', 'บ้าคลั่ง', 'นักวางกับดัก', 'นักบุกโจมตี', 'อึดถึกทน', 'ฟื้นตัวไว', 'ผู้มีบุญ'],
        attackDice: 8,
        defenseDice: 8,
        stats: {
          stamina: 197,
          str: 150,
          int: 41,
          agi: 57,
          luck: 26,
          defense: 25,
        },
      },
    };


    const applyNamePresetIfAny = (name) => {
      const preset = namePresets[name?.trim?.() || name];
      if (!preset) return;

      villagerData.value.weapon = preset.weapon || villagerData.value.weapon;
      villagerData.value.strongAgainst = [...(preset.strongAgainst || [])];
      villagerData.value.weakAgainst = [...(preset.weakAgainst || [])];

      const perkSet = new Set([...(villagerData.value.perks || []), ...(preset.perks || [])]);
      villagerData.value.perks = Array.from(perkSet);

      if (preset.attackDice !== undefined) {
        villagerData.value.attackDice = preset.attackDice;
      }
      if (preset.defenseDice !== undefined) {
        villagerData.value.defenseDice = preset.defenseDice;
      }

      if (preset.stats) {
        villagerData.value.stats = {
          stamina: preset.stats.stamina ?? villagerData.value.stats.stamina ?? 0,
          str: preset.stats.str ?? villagerData.value.stats.str ?? 0,
          agi: preset.stats.agi ?? villagerData.value.stats.agi ?? 0,
          int: preset.stats.int ?? villagerData.value.stats.int ?? 0,
          luck: preset.stats.luck ?? villagerData.value.stats.luck ?? 0,
          defense: preset.stats.defense ?? villagerData.value.stats.defense ?? 0,
        };
      }
    };
    const fetchVillager = async () => {
      try {
        const doc = await projectFirestore.collection('gameVillagers').doc(props.villagerId).get();
        if (doc.exists) {
          villagerData.value = { ...doc.data() };
          // Ensure arrays are initialized
          if (!villagerData.value.phrases || villagerData.value.phrases.length === 0) {
            villagerData.value.phrases = [''];
          }
          if (!villagerData.value.locations || villagerData.value.locations.length === 0) {
            villagerData.value.locations = [''];
          }
          if (!villagerData.value.hireCosts) {
            villagerData.value.hireCosts = { silver: 0, gold: 0, diamond: 0 };
          }
          if (!villagerData.value.stats) {
            villagerData.value.stats = { stamina: 0, str: 0, int: 0, agi: 0, defense: 0, luck: 0 };
          }
          if (!villagerData.value.perks) {
            villagerData.value.perks = [];
          }
          if (!villagerData.value.weapon) {
            villagerData.value.weapon = '';
          }
          if (!villagerData.value.strongAgainst) {
            villagerData.value.strongAgainst = [];
          }
          if (!villagerData.value.weakAgainst) {
            villagerData.value.weakAgainst = [];
          }
          if (!villagerData.value.upgradeItemNames || villagerData.value.upgradeItemNames.length === 0) {
            villagerData.value.upgradeItemNames = ['']; // Default empty string for add
          }
          if (!villagerData.value.upgradeQuantity) {
            villagerData.value.upgradeQuantity = 1;
          }
          if (!villagerData.value.diamondCosts) {
            villagerData.value.diamondCosts = Array(9).fill(0);
          }
          if (!villagerData.value.goldCosts) {
            villagerData.value.goldCosts = Array(9).fill(0);
          }
          if (!villagerData.value.type) {
            villagerData.value.type = 'นักรบรับจ้าง';
          }
          applyNamePresetIfAny(villagerData.value.name);
        } else {
          alert('ไม่พบข้อมูลชาวบ้าน');
          emit('cancelModal');
        }
      } catch (error) {
        console.error('Error fetching villager:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      } finally {
        isLoading.value = false;
      }
    };
    onMounted(fetchVillager);

    // Handle updating villager
    const handleUpdateVillager = async () => {
      try {
        const villagerName = villagerData.value.name.trim();
        if (!villagerName || /[/\.#$$$  $$]/.test(villagerName)) {
          alert('ชื่อชาวบ้านไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }

        // Filter valid phrases
        const filteredPhrases = villagerData.value.phrases.filter(phrase => phrase.trim());
        const filteredLocations = villagerData.value.locations.filter(location => location.trim());
        const filteredItemNames = villagerData.value.upgradeItemNames.filter(name => name.trim());

        const updateData = {
          name: villagerName,
          img: villagerData.value.img,
          normalFace: villagerData.value.normalFace || '',
          phrases: filteredPhrases,
          locations: filteredLocations,
          hireCosts: villagerData.value.hireCosts,
          stats: {
            stamina: villagerData.value.stats.stamina,
            str: villagerData.value.stats.str,
            int: villagerData.value.stats.int,
            agi: villagerData.value.stats.agi,
            defense: villagerData.value.stats.defense,
            luck: villagerData.value.stats.luck,
          },
          level: Number(villagerData.value.level),
          type: villagerData.value.type,
          attackDice: villagerData.value.attackDice,
          defenseDice: villagerData.value.defenseDice,
          weapon: villagerData.value.weapon,
          strongAgainst: villagerData.value.strongAgainst,
          weakAgainst: villagerData.value.weakAgainst,
          perks: villagerData.value.perks,
          upgradeItemNames: filteredItemNames, // Changed
          upgradeQuantity: villagerData.value.upgradeQuantity, // Changed
          diamondCosts: villagerData.value.diamondCosts, // New
          goldCosts: villagerData.value.goldCosts // New
        };

        // Update villager in gameVillagers collection
        await projectFirestore.collection('gameVillagers').doc(props.villagerId).update(updateData);

        emit('cancelModal');
      } catch (error) {
        console.error('Error updating villager:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };

    // Handle deleting villager
    const handleDeleteVillager = async () => {
      if (window.confirm('แน่ใจว่าต้องการลบชาวบ้านนี้ใช่ไหม? การลบนี้ไม่สามารถย้อนกลับได้')) {
        try {
          await projectFirestore.collection('gameVillagers').doc(props.villagerId).delete();
          console.log('Villager deleted successfully:', props.villagerId);
          emit('villagerDeleted');
          emit('cancelModal');
        } catch (error) {
          console.error('Error deleting villager:', error);
          alert(`เกิดข้อผิดพลาดในการลบ: ${error.message}`);
        }
      }
    };

    return { 
      villagerData,
      isLoading,
      activeTab,
      tabs,
      availablePerks,
      weapons,
      handleUpdateVillager,
      handleDeleteVillager,
      addPhrase,
      removePhrase,
      addLocation,
      removeLocation,
      addUpgradeItem,
      removeUpgradeItem
    };
  }
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>